import {Component, FC} from 'react';
import ClockLoader from "react-spinners/ClockLoader";
import { css } from "@emotion/react";

const override: any = css`
  display: block;
  margin: 50px;
`;

function mobile_check(){
    let check = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return check;
};

const PageLoader: FC<any> = ({
    hideText = false
}) => {
    return (
        <div style={
            mobile_check() ? {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                margin: "200px",
                zoom: "200%",
                fontSize: "20px"
            } :
            {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                margin: "300px"
            }
        }>
            <ClockLoader color={"blue"} loading={true} size={150} />
            <br/><br/>
            { !hideText && <p style={ mobile_check() ? {width: "300%", fontSize: "24px", color: "black"} : {fontSize: "14px", color: "black"} }>
                Loading your report...
            </p>
            }
        </div>
    )

}

export default PageLoader;